import React, { useEffect, useContext } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';

import {
  PortalContext,
  addPortal,
  removePortalType,
  removeAll,
} from './PortalContainer';

// import modalHeader from '~/assets/modal-svg.svg';

export function openModal(modal) {
  addPortal({
    type: 'modal',
    component: modal,
  });
}

export function closeAll() {
  removeAll();
}

export function closeModal(child) {
  removePortalType('modal');
}

export const ModalBackdrop = styled.div``;
export const ModalContent = styled.div``;
export const ModalHeader = styled.div``;
export const ModalClose = styled.div``;
export const ModalFooter = styled.div``;
export const ModalBody = styled.div``;

export default function Modal({ header, children, footer, className, onClose = true }) {
  // const portal = useContext(PortalContext);

  const handleModalClose = () => {
    if (typeof onClose === 'function') {
      return onClose();
    } else return closeModal();
  };

  const modal = (
    <ModalContainer className={className}>
      <ModalBackdrop />
      <ModalContent>
        <ModalHeader>
          {header}
          {onClose && <ModalClose onClick={handleModalClose}>×</ModalClose>}
        </ModalHeader>
        <ModalBody>{children}</ModalBody>
        {footer ? <ModalFooter>{footer}</ModalFooter> : null}
      </ModalContent>
    </ModalContainer>
  );

  return modal;
}

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-bottom: 10vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;

  ${ModalBackdrop} {
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    position: absolute;
  }

  ${ModalContent} {
    position: relative;
  }

  ${ModalBody} {
    max-height: calc(90vh - 50px);
    overflow: auto;
    border-radius: 4px;
  }

  ${ModalHeader} {
    display: flex;
    align-items: center;
    padding-bottom: 5px;

    background-size: 20px 20px;
    background-position: 5px 10px;
    padding-left: 40px;
    bottom: 100%;
    font-weight: bold;
    font-size: 20px;
    line-height: 30px;
    color: #ffffff;

    ${ModalClose} {
      font-size: 30px;
      font-weight: normal;
    }
  }

  ${ModalClose} {
    margin-left: auto;
    font-size: 30px;
    opacity: 0.7;
    transition: 0.2s;
    cursor: pointer;
    padding: 5px;
    line-height: 1;
    color: rgba(255, 255, 255, 0.8);

    &:hover {
      opacity: 1;
    }
  }
`;
